/*eslint-disable eqeqeq*/
import React from "react";
import * as APIController from '../../../../api/APIController.js';
import Table from "../../../../shared/components/table/table";
import TableHead from "../../../../shared/components/table/tableHead";
import TableRow from "../../../../shared/components/table/tableRow";
import TableBody from "../../../../shared/components/table/tableBody";
import TableCell from "../../../../shared/components/table/tableCell";
import double_left_arrow from '../../../../assets/images/left-doble-arow.svg';
import left_arrow from '../../../../assets/images/left-arrow.svg';
import double_right_arrow from '../../../../assets/images/right-doble-arow.svg';
import right_arrow from '../../../../assets/images/right-arrow.svg';
import "react-perfect-scrollbar/dist/css/styles.css";
import PageTitle from "../../../../config/pageTitle";
import * as AppConsatnt from "../../../../config/AppConstant";
import PerfectScrollbar from "react-perfect-scrollbar";

import deleteIcon from '../../../../assets/images/delete.svg'
import scheduleIcon from '../../../../assets/images/schedule.svg'
import monthlycalendar from '../../../../assets/images/monthlycalendar.svg'
import editIcon from '../../../../assets/images/edit.svg'
import filtericon from '../../../../assets/images/ic_feather_filter.svg'

import Modal from '../../../../shared/components/modal/modal';
import ConfirmtionDialog from '../../../ConfirmDialog/ConfirmationDialog';
import AddEditCalendarPopup from './addEditCalendarPopup';
import Notification from '../../../../shared/components/notification/notification';
import CircularProgress from "../../../../shared/components/CircularProgress/CircularProgress";

const CalendarListComponent = (props) => {
	const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

	const headerList = ['action', "Year", "Month", "Total Assets", "Cost", "Is Locked ?", "Is Active ?"]
	const { currentPage, count, rowsPerPage, rowsPerPageOptions, list, to, from } = props;
	let countryList = list;
	countryList = list.slice(from, to)

	const page = Math.floor(count / rowsPerPage) + 1;

	const [LoginDialog, setLoginDialog] = React.useState(false);
	const [DeleteId, setDeleteId] = React.useState('');
	const [CalendarId, setCalendarId] = React.useState(0);
	const [CalendarYear, setCalendarYear] = React.useState(new Date().getFullYear());
	const [CalendarMonth, setCalendarMonth] = React.useState(monthNames[new Date().getMonth()]);


	/**
	 * handleChangeInCurrentPage method is used to change page number
	 * it will check that page number does not exist last page
	 * @param {*} value 
	 */
	const handleChangeInCurrentPage = (value) => {
		if (value <= page && Number(parseInt(value))) {
			props.handleChangePage(Number(value));
		}
	}

	const wsDeleteAutomationCalendar = (ID) => {
		APIController.DeleteAutomationCalendar(ID)
			.then((response) => {
				if (response.error == null) {
					if (response.object.status == 1) {
						props.handleNotification(response.object.message);
					} else {
						props.handleNotification(response.object.message, true);
					}
					props.handlebind()
					setLoginDialog(false)
				}
				else if (response.error.message && response.error.message.length > 0) {
					props.handleNotification(response.error.message)
				}
			})
	}

	const [message, setMessage] = React.useState("");
	const [showNotification, setShowNotification] = React.useState(false);
	const [isError, setIsError] = React.useState(false);

	const handleClearNotification = () => {
		setMessage('')
		setShowNotification(false)
		setIsError(false)
	}
	return (
		<>
			<h1><PageTitle Title="View Automation Calendar" /></h1>
			<div className="table-main-wrap">
				<PerfectScrollbar component='div'>
					<Table>
						<TableHead>
							<TableRow>
								{headerList.map((obj, index) => {
									return <TableCell style={index == 0 ? { minWidth: "10%" } : index == 1 ? { minWidth: '150px' } : { width: '20%' }} className={obj === "Is Active ?" || obj === "Is Locked ?" ? 'center' : ''} key={index}>{obj}</TableCell>;
								})}
							</TableRow>
							<TableRow>
								<TableCell> <span><img src={filtericon} alt="delete" /></span> </TableCell>
								<TableCell style={{ minWidth: '150px' }}> <input type="text" name="" placeholder="Search Year" onChange={(e) => props.applyFilter('CalendarYear', e.target.value, 'input')} /> </TableCell>
								<TableCell> <input type="text" name="" placeholder="Search Month" onChange={(e) => props.applyFilter('CalendarMonthName', e.target.value, 'input')} /> </TableCell>
								<TableCell> <input type="text" name="" placeholder="Search Assets" onChange={(e) => props.applyFilter('TotalAssets', e.target.value, 'input')} /> </TableCell>
								<TableCell> <input type="text" name="" placeholder="Search Cost" onChange={(e) => props.applyFilter('Cost', e.target.value, 'input')} /> </TableCell>
								<TableCell>
									<select onChange={(e) => props.applyFilter('IsLockedLABEL', e.target.value, 'select')}>
										<option value={""}>All</option>
										<option value={"YES"}>Yes</option>
										<option value={"NO"}>No</option>
									</select>
								</TableCell>
								<TableCell>
									<select onChange={(e) => props.applyFilter('IsActiveLABEL', e.target.value, 'select')}>
										<option value={""}>All</option>
										<option value={"YES"}>Yes</option>
										<option value={"NO"}>No</option>
									</select>
								</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{!!countryList.length ? countryList.map((obj, idnex) => {
								return (
									<TableRow key={idnex}>
										<TableCell style={{ minWidth: "110px" }}>
											<span>
												<img src={editIcon} alt="edit" style={{ cursor: 'pointer', marginRight: '3px' }}
													onClick={() => {
														props.history.push({
															pathname: '/automationcalendar/add',
															state: { calendarIdEdit: obj.ID, calendarActiveEdit: obj.IsActiveLABEL === "YES" ? 1 : 0 }
														})
													}} />
												<img src={deleteIcon} alt="delete" style={{ cursor: 'pointer', marginRight: '7px' }}
													onClick={() => { setDeleteId(obj.ID); setLoginDialog(true) }} />
												<img src={scheduleIcon} alt="add" style={{ cursor: 'pointer', marginRight: '7px' }}
													onClick={() => {
														setDeleteId("")
														setCalendarId(obj.ID)
														setCalendarYear(obj.CalendarYear)
														setCalendarMonth(obj.CalendarMonth)
														setLoginDialog(true)
													}} />
												<img src={monthlycalendar} alt="edit" style={{ cursor: 'pointer', marginRight: '3px' }}
													onClick={() => { props.history.push({ pathname: "/calendarForAdmin", state: { calendarIdEdit: obj.ID, calendarYearEdit: obj.CalendarYear, calendarMonthEdit: obj.CalendarMonth } }) }} />
											</span>
										</TableCell>
										<TableCell style={{ minWidth: '150px' }}> {obj.CalendarYear} </TableCell>
										<TableCell> {obj.CalendarMonthName} </TableCell>
										<TableCell> {obj.TotalAssets} </TableCell>
										<TableCell> {obj.Cost} </TableCell>
										<TableCell className={obj.IsLockedLABEL === "YES" ? 'green' : 'red'}>
											<span>{obj.IsLockedLABEL === "YES" ? 'Yes' : 'No'}</span>
										</TableCell>
										<TableCell className={obj.IsActiveLABEL === "YES" ? 'green' : 'red'}>
											<span>{obj.IsActiveLABEL === "YES" ? 'Yes' : 'No'}</span>
										</TableCell>
									</TableRow>
								);
							}) : <TableRow>
								<TableCell colSpan={headerList.length} className="not_found">
									{props.progress ?
										<CircularProgress /> :
										<label>Not Currently Available</label>}
								</TableCell>
							</TableRow>}
						</TableBody>
					</Table>
				</PerfectScrollbar>
			</div>
			<Notification
				isError={isError}
				message={message}
				showNotification={showNotification}
				closeNotification={handleClearNotification.bind(this)}
			/>
			{LoginDialog && (
				<Modal
					show={LoginDialog}
					handleClose={() => setLoginDialog(false)}>

					{DeleteId != "" ? <ConfirmtionDialog
						title={"Delete Calendar"}
						description={"Are you sure you want to delete this Calendar?"}
						deletePress={() => wsDeleteAutomationCalendar(DeleteId)}
						closeModal={() => setLoginDialog(false)}
					/> :
						<AddEditCalendarPopup
							closeModal={() => setLoginDialog(false)}
							CalendarId={CalendarId}
							EditID={0}
							CalendarYear={CalendarYear}
							CalendarMonth={CalendarMonth}
							history={props.history}
							titleName={"Calendar " + CalendarYear + ", " + monthNames[CalendarMonth - 1]}
						/>}
				</Modal>
			)}
			<div className="table-pagination">
				<div className="pagination-info">
					<p>Showing {from + 1} - {to > count ? count : to} of {count}</p>
				</div>
				<div className="pagination-control">
					<a href="#!" title="" className={`double-left-arrow ${currentPage === 1 || currentPage === 0 ? 'disabled' : ''}`}
						onClick={(e) => {
							e.preventDefault();
							handleChangeInCurrentPage(1)
						}}
					><img src={double_left_arrow} alt="left" /></a>
					<a href="#!" title="" className={`simple-left-arrow ${currentPage === 1 || currentPage === 0 ? 'disabled' : ''}`}
						onClick={(e) => {
							e.preventDefault();
							handleChangeInCurrentPage(currentPage - 1)
						}}
					><img src={left_arrow} alt="single_left" /></a>
					<span>Page</span>
					<input type="text" name="textbox" value={currentPage === 0 ? currentPage + 1 : currentPage} onChange={(e) => handleChangeInCurrentPage(e.target.value)} />
					<span>of {page}</span>
					<a href="#!" title="" className={`simple-right-arrow ${currentPage === page ? 'disabled' : ''}`}
						onClick={(e) => {
							e.preventDefault();
							handleChangeInCurrentPage(currentPage + 1)
						}}
					><img src={right_arrow} alt="right" /></a>
					<a href="#!" title="" className={`double-right-arrow ${currentPage === page ? 'disabled' : ''}`}
						onClick={(e) => {
							e.preventDefault();
							handleChangeInCurrentPage(page)
						}}><img src={double_right_arrow} alt="single_right" /></a>
					<select onChange={(e) => props.handleChangeRowsPerPage(e.target.value)} defaultValue={rowsPerPage}>
						{
							rowsPerPageOptions.map((obj, index) => {
								return <option value={obj} key={index}>{obj}</option>
							})
						}
					</select>
				</div>
			</div>
		</>
	);
};

export default CalendarListComponent;
